import React, { Component, Fragment } from 'react';
import './ProgramarCalibracion.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getTecnicos} from '../../../redux/actions/useractions';

// MUI v5 imports
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  FormHelperText,
  Select,
  InputLabel,
  CircularProgress,
  Tooltip,
  IconButton,
  Grid,
  Typography
} from '@mui/material';

// Icons
import { FaArrowLeft, FaPlus, FaCalendarDay, FaCheck, FaCheckCircle } from 'react-icons/fa';

import { progCalibracion, clearErrors } from '../../../redux/actions/dataactions';
import MyButton from '../../../utils/MyButton';

export class ProgramarCalibracion extends Component {
  constructor() {
    super();
    this.state = {
      fecha: '',
      hora: '',
      duracion: '',
      lugar: '',
      responsable:'Todos',
      errors: {},
      aprobado: {},
      open: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};

    if (props.UI.errors) {
      newState.errors = props.UI.errors;
    }

    if (props.UI.aprobado) {
      newState.aprobado = props.UI.aprobado;
    }

    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpen = () => {
    this.setState({ open: true, aprobado: {} });
     this.props.getTecnicos(this.props.handleuser);
  };

  handleClose = () => {
    this.props.clearErrors();
    this.setState({ open: false, errors: {}, aprobado: {} });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const fechacal = new Date(this.state.fecha);

    const day = fechacal.getDate() + 1; // mantiene la lógica original
    const mes = fechacal.getMonth() + 1;
    const mesnombre = fechacal.toLocaleString('es-ES', { month: 'long' });
    const year = fechacal.getFullYear();

    const { equipo = {} } = this.props;

    const newProgramacion = {
      fecha: this.state.fecha,
      hora: this.state.hora,
      duracion: this.state.duracion,
      nombre: equipo?.nombre || '',
      marca: equipo?.marca || '',
      lugar: this.state.lugar,
      modelo: equipo?.modelo || '',
      serie: equipo?.serie || '',
      ubicacion: equipo?.ubicacion || '',
      idinventario: equipo?.idinventario || '',
      dia: day,
      mes: mes,
      mesnombre: mesnombre,
      year: year,
      responsable:this.state.responsable
    };

    // console.log(newProgramacion);
    this.props.progCalibracion(newProgramacion, this.props.clienteId, this.props.equipoId);
  };

  render() {
    const {
      UI: { loading },
    } = this.props;
    const { errors } = this.state;
const labelSx = { color: '#0468BF', fontSize: 18, fontWeight: 400, ml: 1, mb: 1 };
const fieldSx = { '& .MuiOutlinedInput-root': { borderRadius: 2 } };
    return (
      <div>
        <Fragment>
          {/* Botón de apertura: Icono + Tooltip */}

           <MyButton tip="Programar calibración" onClick={this.handleOpen}>
                      <FaCalendarDay color="#03178C" className="icon-crearcliente"/>
                       </MyButton>
          

          <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="sm">
            {this.state.aprobado.mensaje ? (
              <div className="div-aprobado">
                <div className="div-icono-aprobado">
                  <FaCheck color="#ffffff" className="icono-aprobado" />
                </div>
                <Typography variant="h6" align="center" className="text-aprobado">
                  ¡Programación de Calibración Exitosa!
                </Typography>
              </div>
            ) : (
              <div>
            <DialogTitle sx={{ pb: 0 }}>
<Typography sx={{ 
                                                                         fontSize: '20px', 
                                                                         fontWeight: 600, 
                                                                         color: '#0468BF', 
                                                                         textAlign: 'center' 
                                                                     }}>
                                                                         Programar Calibración
                                               </Typography>
</DialogTitle>

<DialogContent>
  <form onSubmit={this.handleSubmit}>
    <Grid container spacing={1} sx={{ mt: 0.5 }}>

      {/* Fecha */}
      <Grid item xs={12}>
        <FormControl fullWidth margin="normal">
          <Typography sx={{ color: '#0468BF', fontSize: '18px', fontWeight: 400, ml: 1, mb: 1 }}>
            Fecha de calibración
          </Typography>
          <TextField
            required
            type="date"
            name="fecha"
            id="fecha"
            label="Selecciona la fecha"
            value={this.state.fecha || ''}
            onChange={this.handleChange}
            fullWidth
            size="small"
            variant="outlined"
            helperText={errors.fecha}
            error={Boolean(errors.fecha)}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
      </Grid>

      {/* Hora */}
      <Grid item xs={12}>
        <FormControl fullWidth margin="normal">
          <Typography sx={{ color: '#0468BF', fontSize: '18px', fontWeight: 400, ml: 1, mb: 1 }}>
            Hora de calibración
          </Typography>
          <TextField
            required
            type="time"
            name="hora"
            id="hora"
            label="Selecciona la hora"
            value={this.state.hora || ''}
            onChange={this.handleChange}
            fullWidth
            size="small"
            variant="outlined"
            helperText={errors.hora}
            error={Boolean(errors.hora)}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
      </Grid>

      {/* Duración */}
      <Grid item xs={12}>
        <FormControl fullWidth margin="normal">
          <Typography sx={{ color: '#0468BF', fontSize: '18px', fontWeight: 400, ml: 1, mb: 1 }}>
            Duración en horas
          </Typography>
          <TextField
            select
            required
            name="duracion"
            id="duracion"
            label="Selecciona una duración"
            value={this.state.duracion || ''}
            onChange={this.handleChange}
            fullWidth
            size="small"
            variant="outlined"
            helperText={errors.duracion}
            error={Boolean(errors.duracion)}
          >
            <MenuItem disabled value="">
              <em>Selecciona una duración</em>
            </MenuItem>
            {['0.5','1','2','3','4','5','6','7','8'].map(v => (
              <MenuItem key={v} value={v}>{v}</MenuItem>
            ))}
          </TextField>
        </FormControl>
      </Grid>

      {/* Lugar */}
      <Grid item xs={12}>
        <FormControl fullWidth margin="normal">
          <Typography sx={{ color: '#0468BF', fontSize: '18px', fontWeight: 400, ml: 1, mb: 1 }}>
            Lugar de calibración
          </Typography>
          <TextField
            select
            required
            name="lugar"
            id="lugar"
            label="Selecciona el lugar"
            value={this.state.lugar || ''}
            onChange={this.handleChange}
            fullWidth
            size="small"
            variant="outlined"
            helperText={errors.lugar}
            error={Boolean(errors.lugar)}
          >
            <MenuItem disabled value="">
              <em>Selecciona el lugar</em>
            </MenuItem>
            <MenuItem value="Laboratorio">Laboratorio</MenuItem>
            <MenuItem value="En Sitio">En Sitio</MenuItem>
          </TextField>
        </FormControl>
      </Grid>

      {/* Responsable */}
      <Grid item xs={12}>
        <FormControl fullWidth margin="normal">
          <Typography sx={{ color: '#0468BF', fontSize: '18px', fontWeight: 400, ml: 1, mb: 1 }}>
            Responsable
          </Typography>
          <TextField
            select
            name="responsable"
            id="responsable"
            label="Seleccione un responsable"
            value={this.state.responsable || ''}
            onChange={this.handleChange}
            fullWidth
            size="small"
            variant="outlined"
            helperText={errors.responsable}
            error={Boolean(errors.responsable)}
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {this.props.tecnicos && this.props.tecnicos.map((handle, index) => (
              <MenuItem key={index} value={handle}>
                {handle}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>
      </Grid>

    </Grid>
  </form>
</DialogContent>
              </div>
            )}

            <DialogActions>
              {/* Cerrar */}
              <Tooltip title="Cerrar">
                <span>
                  <IconButton onClick={this.handleClose} size="small">
                    <FaArrowLeft className="icon-formulario" />
                  </IconButton>
                </span>
              </Tooltip>

              {/* Estados de acción */}
              {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />)
                : this.state.aprobado.mensaje ? (
                  <Tooltip title="Continuar">
                    <IconButton onClick={this.handleClose} size="small">
                      <FaCheckCircle color="#03178C"className="icon-formulario" />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title="Programar calibración">
                    <IconButton onClick={this.handleSubmit} size="small">
                      <FaPlus color="#03178C" className="icon-formulario" />
                    </IconButton>
                  </Tooltip>
                )}
            </DialogActions>
          </Dialog>
        </Fragment>
      </div>
    );
  }
}

ProgramarCalibracion.propTypes = {
  progCalibracion: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
   getTecnicos:PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  equipo: PropTypes.object,
  clienteId: PropTypes.string,
  equipoId: PropTypes.string,
};

const mapStateToProps = (state) => ({
   user:state.user,
      data:state.data,
  UI: state.UI,

  equipo: state.data.equipo.credentials,
      handleuser: state.user.credentials.handle,
       tecnicos: state.user.tecnicos,
});

export default connect(mapStateToProps, {getTecnicos, progCalibracion, clearErrors })(ProgramarCalibracion);
